<template>
  <div class="point-grounp">
    <span
      class="point"
      :class="{ active: index === PageIndex }"
      v-for="(item, index) in 5"
      :key="index"
      @click="
        pointClick(index);
        childChangeIndex();
      "
    ></span>
  </div>
</template>

<script>
export default {
  props: {
    activeIndex: {
      type: Number,
      default: 0,
    },
    PageIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      currentIndex: this.activeIndex,
    };
  },
  methods: {
    pointClick(index) {
      this.currentIndex = index;
      // this.currentIndex = this.PageIndex
      this.$emit("childIndex2", index);
      console.log("point", index);
    },
    childChangeIndex() {
      console.log("childChangeIndex===>", this.currentIndex);
      this.$emit("childIndex", this.currentIndex);
    },
  },
};
</script>

<style lang="less" scoped>
.point-grounp {
  position: fixed;
  top: 0;
  bottom: 0;
  height: 120px;
  right: 30px;
  margin: auto;
  display: flex;
  flex-direction: column;
  z-index: 2;

  .point {
    display: block;
    width: 16px;
    height: 16px;
    margin-bottom: 5px;
    border: 1px solid #ddd;
    border-radius: 50%;
    background-color: transparent;

    &.active {
      background-color: #bbb;
    }
  }
}
</style>
